import { createContext, useContext } from 'react'

export const CandidateContext = createContext()

export function useCandidate() {
  return useContext(CandidateContext)
}